.academicYear {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-3x);

    .header {
        height: var(--bi-scale-12x);
        width: 100%;
        border-bottom: 1px solid var(--bi-color-stroke-basic-subtle);
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--bi-scale-4x);

        h3 {
            color: var(--bi-color-text);
            font: var(--bi-font-title-bold-medium);
            white-space: nowrap;
        }
        p {
            font: var(--bi-font-title-regular-xxs);
            color: var(--bi-color-text-secondary);
        }
    }

    .semesters {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: var(--bi-scale-6x) var(--bi-scale-8x);

        @media (width < 768px) {
            grid-template-columns: 1fr;
            grid-auto-flow: row;
        }

        .semester {
            h4 {
                font: var(--bi-font-title-bold-xs);
                color: var(--bi-color-text-accent);
            }

            > ul {
                display: grid;
                grid-auto-flow: row;
                grid-auto-rows: minmax(calc(var(--bi-scale-10x) + var(--bi-stroke-thin) * 2), auto);
                gap: var(--bi-scale-3x);
                margin-top: var(--bi-scale-3x);

                @media (width < 768px) {
                    gap: var(--bi-scale-2x);
                    margin-top: var(--bi-scale-2x);
                }
            }

            &:only-child {
                grid-column: 1 / -1;

                > ul {
                    grid-template-columns: repeat(2, 1fr);
                    column-gap: var(--bi-scale-8x);

                    @media (width < 768px) {
                        grid-template-columns: 1fr;
                    }
                }
            }
        }
    }
}
